import { Theme } from 'config';

const styles = (theme: Theme) => ({
  charts: {
    padding: '0 1em !important',

    '& .statistic': {
      width: '100%',
    },
  },
  gridTable: {
    overflowX: 'auto !important',
  },
  tableHeader: {
    background: `${theme.violet} !important`,
    color: '#fff !important',
    fontSize: '1em !important',
  },
  label: {
    fontSize: '0.75em !important',
    marginBottom: 8,
    color: 'rgba(0,0,0,.5) !important',
  },
  value: {
    color: `${theme.violet} !important`,
  },
});

export default styles;
